import React from 'react';
import { Download, X } from 'lucide-react';
import { generatePurchasePDF, downloadPDF } from '../utils/exportUtils';
import '../styles/Modal.css';

function PurchaseViewModal({ purchase, onClose }) {
  if (!purchase) return null;

  const handleDownloadPDF = () => {
    const doc = generatePurchasePDF(purchase);
    downloadPDF(doc, `Purchase_${purchase.purchaseNumber}.pdf`);
  };

  return (
    <div className="modal-overlay">
      <div className="modal purchase-view-modal">
        <div className="modal-header">
          <h2>Purchase Details - {purchase.purchaseNumber}</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <div className="purchase-view-content">
          {/* Header */}
          <div className="purchase-view-header">
            <div className="purchase-title">
              <h3>SSP BILLING SYSTEM</h3>
              <p className="purchase-type">PURCHASE ORDER</p>
            </div>
            <div className="purchase-details-info">
              <p><strong>Purchase No:</strong> {purchase.purchaseNumber}</p>
              <p><strong>Date:</strong> {new Date(purchase.purchaseDate).toLocaleDateString('en-IN')}</p>
              <p><strong>Payment Mode:</strong> {purchase.paymentMode}</p>
            </div>
          </div>

          {/* Supplier Details */}
          <div className="purchase-supplier-box">
            <h4>Supplier Details:</h4>
            <p><strong>{purchase.supplierName}</strong></p>
            <p>Phone: {purchase.supplierPhone}</p>
            {purchase.supplierGSTIN && <p>GSTIN: {purchase.supplierGSTIN}</p>}
          </div>

          {/* Items Table */}
          <div className="purchase-items-section">
            <h4>Products Purchased</h4>
            <table className="purchase-view-table">
              <thead>
                <tr>
                  <th>SL</th>
                  <th>Product</th>
                  <th>HSN</th>
                  <th>Qty</th>
                  <th>Rate</th>
                  <th>Tax%</th>
                  <th>Subtotal</th>
                  <th>CGST</th>
                  <th>SGST</th>
                  <th>IGST</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {purchase.items && purchase.items.map((item, idx) => {
                  const subtotal = item.purchasePrice * item.quantity;
                  const totalTax = (item.cgst || 0) + (item.sgst || 0) + (item.igst || 0);
                  const total = subtotal + totalTax;
                  
                  return (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td>{item.productName}</td>
                      <td>{item.hsnCode}</td>
                      <td className="text-right">{item.quantity.toFixed(2)}</td>
                      <td className="text-right">₹{item.purchasePrice?.toFixed(2) || '0.00'}</td>
                      <td className="text-right">{item.taxRate}</td>
                      <td className="text-right">₹{subtotal.toFixed(2)}</td>
                      <td className="text-right">₹{(item.cgst || 0).toFixed(2)}</td>
                      <td className="text-right">₹{(item.sgst || 0).toFixed(2)}</td>
                      <td className="text-right">₹{(item.igst || 0).toFixed(2)}</td>
                      <td className="text-right"><strong>₹{total.toFixed(2)}</strong></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          {/* Tax Summary */}
          <div className="purchase-tax-section">
            <h4>Tax Breakdown</h4>
            <table className="tax-summary-table">
              <tbody>
                <tr>
                  <td><strong>CGST (Central GST):</strong></td>
                  <td className="text-right">
                    ₹{purchase.items?.reduce((sum, item) => sum + (item.cgst || 0), 0).toFixed(2) || '0.00'}
                  </td>
                </tr>
                <tr>
                  <td><strong>SGST (State GST):</strong></td>
                  <td className="text-right">
                    ₹{purchase.items?.reduce((sum, item) => sum + (item.sgst || 0), 0).toFixed(2) || '0.00'}
                  </td>
                </tr>
                <tr>
                  <td><strong>IGST (Integrated GST):</strong></td>
                  <td className="text-right">
                    ₹{purchase.items?.reduce((sum, item) => sum + (item.igst || 0), 0).toFixed(2) || '0.00'}
                  </td>
                </tr>
                <tr className="tax-total-row">
                  <td><strong>Total Tax:</strong></td>
                  <td className="text-right"><strong>₹{(purchase.totalTax || 0).toFixed(2)}</strong></td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Totals */}
          <div className="purchase-totals-section">
            <div className="totals-summary">
              <div className="summary-row">
                <span>Subtotal:</span>
                <strong>₹{(purchase.subtotal || 0).toFixed(2)}</strong>
              </div>
              <div className="summary-row">
                <span>Total Tax:</span>
                <strong>₹{(purchase.totalTax || 0).toFixed(2)}</strong>
              </div>
              <div className="summary-row grand-total-row">
                <span>GRAND TOTAL:</span>
                <strong>₹{(purchase.grandTotal || 0).toFixed(2)}</strong>
              </div>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>Close</button>
          <button className="btn btn-primary" onClick={handleDownloadPDF}>
            <Download size={18} /> Download PDF
          </button>
        </div>
      </div>
    </div>
  );
}

export default PurchaseViewModal;
